import api from './api';

export const tierApi = {
  // Get all tier settings
  async getTierSettings() {
    const response = await api.get('/tiers');
    return response.data;
  },

  // Get tier statistics
  async getStatistics() {
    const response = await api.get('/tiers/statistics');
    return response.data;
  },

  // Update tier settings
  async updateTier(tier, data) {
    const response = await api.put(`/tiers/${tier}`, data);
    return response.data;
  },

  // Initialize default tier settings
  async initialize() {
    const response = await api.post('/tiers/initialize');
    return response.data;
  },

  // Assign all golfer tiers based on rankings
  async assignAll() {
    const response = await api.post('/tiers/assign-all');
    return response.data;
  },

  // Get golfers in a specific tier
  async getGolfersByTier(tier) {
    const response = await api.get(`/tiers/${tier}/golfers`);
    return response.data;
  },

  // Update golfer ranking and reassign tier
  async updateGolferRanking(golferId, worldRanking) {
    const response = await api.put(`/tiers/golfer/${golferId}/ranking`, {
      worldRanking
    });
    return response.data;
  }
};